import * as hexCSS from './hex.scss';
import * as colorPaletteCSS from './palette.scss';
import * as backgroundHexCSS from './background-hex.scss';
import isColorLight from './is-color-light';
import shadeBlend from './shade-blend';
import type from './type.js';
import { hexToRgb, rgbToHex } from './conversion.js';

const hex = __NATIVE__ ? hexCSS : hexCSS.default;
const colorPalette = __NATIVE__ ? colorPaletteCSS : colorPaletteCSS.default;
const hexKeys = Object.keys(hex).filter(key => typeof hex[key] === 'string');
const backgroundHex = __NATIVE__ ? backgroundHexCSS : backgroundHexCSS.default;
const backgroundHexKeys = Object.keys(backgroundHex).filter(
  key => typeof backgroundHex[key] === 'string'
);

const typeOptions = Object.keys(type).map(t =>
  t.toLowerCase().replace(/_/g, '-')
);

export default {
  hex,
  hexKeys,
  backgroundHex,
  backgroundHexKeys,
  isColorLight,
  shadeBlend,
  type,
  typeOptions,
  hexToRgb,
  rgbToHex,
  colorPalette
};
